
// pages/users/ClientsPage.jsx
import UserRolePage from './UserRolePage.jsx';
export default function ClientsPage() {
  return <UserRolePage role="client" title="Clients / End Users" accentColor="#64748b"
    roleOptions={['client']} />;
}